import React from 'react';
import {
  Paper,
  Container
} from '@mui/material';
import Grid from '@mui/material/Grid2';
import MeusDados from './MeusDados';
import Senha from './Senha';


const Perfil = () => {

  return (
    <Container maxWidth="false" sx={{'my':3}}>
      <Grid container spacing={3} >
        <Grid size={{ xs: 6 }}>
          <Paper variant="elevation" elevation={2} sx={{
            textAlign: 'center',
            px: 4,
            pt: 2,
            pb: 3,
            
            minHeight: '100%'
          }}>
            <MeusDados />
          </Paper>
        </Grid>
        <Grid size={{ xs: 6 }}>
          <Paper variant="elevation" elevation={2} sx={{
            textAlign: 'center',
            px: 4,
            pt: 2,
            pb: 3,
           
            minHeight: '100%'
          }}>
            <Senha />
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Perfil;
